<template lang="pug">
AppPopover(
  ref="AppPopover"
  placement="top"
  hide-close
)
  template(#body)
    span
      slot(name="body")
  template(#trigger)
    span
      slot(name="trigger")
</template>

<script>
export default {
  name: 'AppHintPopover',
  mounted() {
    this.$refs.AppPopover.open();
  },
};
</script>
